import { IQueryBuilderInstance } from '../interfaces';

export class QueryParser {

    /**
     * Parse a query and execute it on an array of objects
     *
     * @param arrayOfObjects
     * @param query
     */
    public static parse(arrayOfObjects: any[], query: IQueryBuilderInstance) {
        const executionCode = this.parseStatements(query.where, '');

        let filtered = arrayOfObjects;

        if (query.where.length) {
            filtered = arrayOfObjects.filter(item => {
                try {
                    return eval(executionCode);
                } catch (e) {
                    console.error('Error while executing filter', executionCode);
                    return arrayOfObjects;
                }
            });
        }

        if (query.orderBy) {
            filtered.sort((a: any, b: any) => {
                // different sort when type is number
                if (typeof a[query.orderBy] === 'number') {
                    return a[query.orderBy] - b[query.orderBy];
                } else {
                    return ('' + a[query.orderBy]).localeCompare(b[query.orderBy]);
                }
            });

            if (query.orderByDirection === 'desc') {
                filtered.reverse();
            }
        }

        if (query.perPage) {
            const page  = query.page || 1;
            const start = (page - 1) * query.perPage;
            const end   = page * query.perPage;
            filtered    = filtered.slice(start, end);
        }

        return filtered;
    }

    /**
     * Parse an array of statements and return a
     * string that can be executed by eval
     *
     * @param statements
     * @param executionCode
     */
    protected static parseStatements(statements: any[], executionCode: string) {
        let mode: AndOrOperators = '&&';

        for (const statement of statements) {
            if (statement instanceof Array) {
                executionCode += this.addAndOrOperator(executionCode, mode);
                mode = '&&';

                executionCode += ' (';
                executionCode += this.parseStatements(statement, '');
                executionCode += ')';
            } else if (statement instanceof Object) {
                executionCode += this.addAndOrOperator(executionCode, mode);
                mode = '&&';
                executionCode += this.generateStatementString(statement);
            } else if (statement === 'or') {
                mode = '||';
            }
        }

        return executionCode;
    }

    /**
     * Generate a statement string based on
     * the given operator
     *
     * @param statement
     */
    protected static generateStatementString(statement) {
        switch (statement.op) {
            case '=':
            case '<':
            case '>=':
            case '<=':
            case '<>':
            case '>':
                return ' item[\'' + statement.attr + '\'] ' + this.getComparisonOperator(statement.op) + ' \'' + statement.val + '\'';

            case 'LIKE':
                const startsWith = statement.val.substr(0, 1) !== '%';
                const endsWith   = statement.val.substr(-1) !== '%';

                let regex = '';
                regex += startsWith ? '^' : '';
                regex += statement.val.replace(/%/g, '');
                regex += endsWith ? '$' : '';

                const regexp = new RegExp(regex, 'i');
                return ' item[\'' + statement.attr + '\'].match(' + regexp.toString() + ') !== null';

            case 'IN':
            case 'NOT IN':
                return '[' + statement.val.join(',') + '].indexOf(item[\'' + statement.attr + '\']) ' + (statement.op === 'IN' ? '>= 0' : '=== -1');

            case 'BETWEEEN':
                return ' item[\'' + statement.attr + '\'] >= ' + statement.val + ' item[\'' + statement.attr + '\'] <= ' + statement.val;

            default:
                return '';
        }
    }

    /**
     * Get the mapped comparison operator
     *
     * @param operator
     */
    protected static getComparisonOperator(operator: string) {
        const operatorMap = {
            '=': '==',
            '>': '>',
            '<': '<',
            '>=': '>=',
            '<=': '<=',
            '<>': '!=',
            'LIKE': 'LIKE',
            'IN': 'IN',
            'NOT IN': 'NOT IN',
            'BETWEEN': 'BETWEEN'
        };

        return operatorMap[operator];
    }

    /**
     * Check if we need to add an operator
     *
     * @param executionCode
     * @param mode
     */
    protected static addAndOrOperator(executionCode: string, mode: AndOrOperators) {
        return executionCode.length > 0 ? mode : '';
    }
}

type AndOrOperators = '&&' | '||';


// WEBPACK FOOTER //
// ./libs/chassis-resource/src/utils/query-parser.ts